import script from "./PlatformDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDetails.vue?vue&type=script&setup=true&lang=js"

import "./PlatformDetails.vue?vue&type=style&index=0&id=3a4a95fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4a95fe"]])

export default __exports__